var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEkata = function SvgEkata(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0886 2.25673V4.4995C13.0886 4.72435 12.9063 4.90662 12.6815 4.90662H6.59022C6.36537 4.90662 6.18309 5.0889 6.18309 5.31374V10.7934C6.18309 11.0182 6.36537 11.2005 6.59023 11.2005H12.6815C12.9063 11.2005 13.0886 11.3828 13.0886 11.6076V13.7425C13.0886 13.9673 12.9063 14.1496 12.6815 14.1496H3.3173C3.09244 14.1496 2.91016 13.9673 2.91016 13.7425V2.25673C2.91016 2.03189 3.09244 1.84961 3.3173 1.84961H12.6815C12.9063 1.84961 13.0886 2.03189 13.0886 2.25673Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18359 7.14833V8.81569C7.18359 9.04053 7.36585 9.22278 7.59077 9.22278H11.3801C11.605 9.22278 11.7873 9.04053 11.7873 8.81569V7.14834C11.7873 6.92349 11.605 6.74121 11.3801 6.74121H7.59077C7.36585 6.74121 7.18359 6.92349 7.18359 7.14833Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEkata);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ekata.b78dc4a2387dcb8b596f1fc9bb039e36.svg";